import React from 'react';
import styles from './Education.module.css';
import { education } from '../data/portfolio';

export default function Education() {
  return (
    <div className="stack fade-in" style={{ marginBottom: '64px' }}>
      <div className="stack-inner">
        <div className={styles.inner}>
          {education.map((e) => (
            <div key={e.degree}>
              <div className={styles.degree}>{e.degree}</div>
              <div className={styles.school}>{e.school}</div>
              <div className={styles.meta}>{e.meta}</div>
              <span className={styles.badge}>{e.grade}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
